import type { FC } from 'react';

import { useLinkComponent } from '@eneco/link';
import { NavLink } from '@eneco/sparky';
import type { HeaderLinkRendering } from '@sitecore/types/HeaderLink';

const HeaderLink: FC<HeaderLinkRendering> = ({ fields }) => {
  const Link = useLinkComponent();

  return (
    <Link href={fields.link.value.href} linkType={fields.link.value.linktype}>
      <NavLink variant="tertiary" tone="onColor">
        {fields.link.value.text}
      </NavLink>
    </Link>
  );
};

export default HeaderLink;
